import { format } from "date-fns";
import moment from "moment";
var validGraduationDate = function validGraduationDate(value) {
  var currentDate = moment(format(new Date(), "yyyy-MM-dd"));
  var errors;
  if (moment(value).isBefore(currentDate)) {
    errors = "Date cannot be in the past.";
  }
  return errors;
};
export default validGraduationDate;